import { Stack, Typography } from "@material-ui/core";
import { Box } from "@material-ui/system";
import { AppchainInfo } from "src/components/AppchainInfo";
import { ProviderItems, StakingPoolItemModel } from "src/models/StakingPool";

import myriadIcon from "src/assets/images/icon_myriad.png";
import deBioIcon from "src/assets/images/icon_deBio.png";
import cipherParatimeIcon from "src/assets/images/icon_cipherParatime.svg";
import deFiKingdomsIcon from "src/assets/images/icon_deFiKingdoms.png";
import appchainBG from "src/assets/images/appchainBG.svg";
import { useStakingInfo } from "src/hooks/useStakingInfo";
import { useEffect, useState } from "react";
import { DelegateTokenModal } from "src/modals/DelegateTokenModal";

const infrastructureProviderDatas: ProviderItems[] = [{
  nodeName: "Myriad",
  subTitle: "Near",
  buttonText: "Delegate",
  url: " ",
  icon: myriadIcon
}, {
  nodeName: "DeBio",
  subTitle: "Near",
  buttonText: "Delegate",
  url: "",
  icon: deBioIcon
}, {
  nodeName: "Cipher paratime",
  subTitle: "Oasis",
  buttonText: "Details",
  url: "https://www.oasisscan.com/validators/detail/oasis1qz65awwegd9pr8msfxkg7hpwyjemm2qdlysyc8jq",
  icon: cipherParatimeIcon
}, {
  nodeName: "DeFi Kingdoms",
  subTitle: "Avalanche",
  buttonText: "Soon",
  url: "",
  type: "Soon",
  icon: deFiKingdomsIcon
}];
export const Appchain = () => { 
  
 
  return (
    <>
      <Box style={{
        width: "100%",
        background: "linear-gradient(to right,#FFFFFF,#FFFFFF,#FFFFFF,#FFFFFF,#E4F0FF)",

      }} display="flex" flexDirection="column" alignItems="center">
        <Box p="50px 95px 92px" width="1280px" position="relative">
          <img src={appchainBG} style={{
            top: "52px",
            right: "100px",
            position: 'absolute'
          }} />
          <Typography
            fontSize="30px"
            variant="bold"
            color="#0E1011"
            lineHeight="30px"
          >
            Appchain Validator
          </Typography>

          <Typography fontSize="16px" lineHeight="16px" color="#848484" mt="20px">
            How to delegate to the Wetez validator
          </Typography>

          <Typography
            fontSize="16px"
            lineHeight="16px"
            color="#0E1011"
            mt="20px"
          >
            Step1: Find the Token Portal you want to stake
          </Typography>

          <Typography
            fontSize="16px"
            lineHeight="16px"
            color="#0E1011"
            mt="8px"
          >
            Step2: Click the Delegate button and get the delegated info
          </Typography>
          <Typography
            fontSize="16px"
            lineHeight="16px"
            color="#0E1011"
            mt="8px"
          >
            Step3: Follow the delegate info and delegate your stake, then sit behind and enjoy the reward.
          </Typography>

        </Box>
      </Box>

      <Box display="flex" flexDirection="column" alignItems="center">
        <Box width="1280px" id="pools">
          <AppchainInfo datas={infrastructureProviderDatas}
            moreUrl="/stakingPools" />
        </Box>
      </Box>

    
    </>
  );
};